<!--
	作者：Shujuan Sun
	时间：2017-05-17
	描述：车辆监控页面_地图组件_街景窗口
-->

<template>
	<div v-bind:style="mapStyle"  class="street_module">
	<div class="tab-title"><span>街景窗口</span> <em  @click="closeStreet"></em></div>
		<baidu-map style="height: 100%;box-shadow: 3px 3px 2px #888888" 
			:center="mapCenter" 
			:zoom="16" 
			:scroll-wheel-zoom="enableScroll" 
			@ready="ready">
		</baidu-map>
		<div style="width:100%;height:100%;position:absolute;left:0;top:30px;" id="panorama"></div>
	</div>
</template>

<script>
	export default {
		name: 'StreetMap',
		props: ['viewPosi'],
		data() {
			return {
				//地图类
				mapStyle: {
					width: '100%',
					height: '400px',
					border:'0px solid #ddd'
				},
				enableScroll:true,
				mapCenter:{lng: 120.39, lat: 36.073}
			}
		},
		methods: {
			ready(obj) {
				const { BMap, map } = obj; 
				if(this.viewPosi.lat!='' && this.viewPosi.lng!=''){
					//添加全景图层，并设置地图中心点。
					map.addTileLayer(new BMap.PanoramaCoverageLayer()); 
					this.mapCenter = this.viewPosi;
					//创建全景实例
					var panorama = new BMap.Panorama('panorama');
				// TODO-- 只有定位在街上的点才能点开街景，所以有的点不显示 
					//显示特地位置的全景图
					panorama.setPosition(new BMap.Point(Number(this.viewPosi.lng),Number(this.viewPosi.lat)))
					//设置全景视角
					panorama.setPov({heading:-40,pitch:6});
					//创建全景数据实例
					var panoramaService = new BMap.PanoramaService();
					//根据坐标返回全景数据
					const that = this;
					panoramaService.getPanoramaByLocation(new BMap.Point(Number(this.viewPosi.lng),Number(this.viewPosi.lat)), function(data){      //2  
					    var panoramaInfo="";  
					    if (data == null) {  
					        that.$store.dispatch('tipModalShow','抱歉,该车辆所在位置没有街景数据') 
					        return;  
					    }   
					}); 
				}else{
					this.$store.dispatch('tipModalShow','未能成功定位车辆位置')
					this.getBrowserPos(map,BMap)
				}
			},
			closeStreet(){
				this.$emit('closeView')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// StreetMap.vue?45e87868